<template>
    <div>

        <vue-headful title="Send Disciplinary Action Email :: MeritEHS"/>

        <div v-if="loading">
            <i class="fa fa-spin fa-spinner"></i>
        </div>
        <template v-else>
            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0">
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/employees/disciplinary-actions`">
                            <i class="fa fa-gavel"></i> Disciplinary Actions
                        </router-link>
                    </li>
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/employees/disciplinary-actions/view/${id}`">
                            <template v-if="action.disc_violation_id">{{ action.violation_name }}</template>
                            <template v-else>{{ action.other_violation_name }}</template>
                             on {{ action.disc_action_date | moment("MM/DD/YYYY") }} by {{ action.employee_first_name }} {{ action.employee_last_name }}
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active">
                        Email Employee
                    </li>
                </ol>
            </h4>

            <div class="row">
                <div class="col-xl-8 col-lg-12">
                    <div class="card">
                        <div class="card-header">
                            Send Disciplinary Action Email
                        </div>
                        <div class="card-body">
                            <div v-if="!action.employee_email" class="alert alert-warning" v-show="flag">
                                <b style="color:red;">This employee does not have an email on file </b> <br><br>
                                <div class="row form-group">
                                    <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right" :class="{'text-danger': errors.email}">Enter the email:</label>
                                    <div class="col-sm-8">
                                        <input type="text" name="email" v-model="employee.email" v-on:click="getEmployee()" :class="{'form-control': true, 'is-invalid': errors.email}" placeholder="Enter Email" />
                                        <span v-if="errors.email" class="text-danger">
                                            <span v-for="error in errors.email">{{ error }}</span>
                                        </span> <br>
                                         Note: The given email will also be updated onto this employee's records.
                                    </div>
                                    <div class="col-sm-8">
                                    <button style="float:right" type="button" class="btn btn-success mt-4" v-on:click="saveEmail()" :disabled="saving"><span>Save Email </span>
                                    </button>
                                    </div>
                                </div>
                            </div>
                            <div v-show="!flag">
                                <p>You are about to Email the Disciplinary Action ->
                                <template v-if="action.disc_violation_id"> <b><i> "{{ action.violation_name }}"</i></b></template>
                                <template v-else> <b> <i>"{{ action.other_violation_name }}" </i></b></template>
                                to the following employee for Acknowledgement: </p>

                                <p> <b>Employee Name: </b> <router-link :to="`/employees/view/${action.employee_id}`">{{ action.employee_first_name }} {{ action.employee_last_name }} </router-link> </p>
                                <p> <b>Employee Email: </b> {{ employee.email }}{{ action.employee_email }} </p>

                                 <button class="btn btn-sm btn-warning" v-on:click="sendEmail()" :disabled="sending">Send Email</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    export default {

        data: function() {
            return {
                loading: true,
                sending: false,
                id: this.$route.params.id,
                action: {
                    employee_id: null,
                },
                errors: {},
                employee: {
                    division_id: null,
                    subcontractor_id: null,
                    email: null,
                },
                displayEmployee: {},
                user: null,
                errors: {},
                divisions: [],
                subcontractors: [],
                is_linked_to_user: false,
                flag: true,
            }
        },

        computed: {

        },

        methods: {
            getAction(){
                //Send it
                this.$http.get('employees/disciplinary-actions/email/'+this.id)
                    .then(response => {
                        //Set
                        this.action = response.data.action;

                        if(this.action.employee_email != null){
                            this.flag=false;
                        }

                    })
                    .then(() => {
                        //Loading
                        this.loading = false;
                    })
            },

            sendEmail(){
                //Signing
                this.sending = true;

                //Send it
                this.$http.post('/employees/disciplinary-actions/email/'+this.id)
                    .then(res => {
                        //Alert the User
                        this.$toastr.success('Email Sent');

                        //Send back to the Disc View
                        this.$router.push('/employees/disciplinary-actions/view/'+this.id);
                    })
                    .catch(err => {
                        //Alert
                        console.log(err);
                    })
                    .then(() => {
                        //reset
                        this.sending = false;
                    });
            },

            getEmployee() {
                //Get the data
                this.$http
                    .get('employees/edit/' + this.action.employee_id)
                    .then(response => {
                        //Set all the data
                        this.employee = response.data.employee;
                        this.divisions = response.data.divisions;
                        this.subcontractors = response.data.subcontractors;
                        this.displayEmployee = Object.assign({}, this.employee);
                        this.user = response.data.user;
                        this.is_linked_to_user = this.user ? true : false;

                        //Set loading
                        this.loading = false;
                    })
                    .catch(response => {

                    });
            },

            saveEmail() {
                //Reset the errors
                this.errors = {};

                if (this.employee.email == null) {
                    alert("Email ID cannot be empty");
                    return;
                }

                //Send it
                this.$http
                .post('employees/edit/' + this.action.employee_id, this.employee)
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('Employee Records Updated');
                    this.flag=false;
                    
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data;
                    }
                })
            },
        },

        mounted(){
            this.getAction();
        }
    }
</script>